import React, { useState, useEffect } from "react";
import "./CenterImageSlider.css";

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to move to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Autoplay functionality
  useEffect(() => {
    const interval = setInterval(nextSlide, 4000); // 4 seconds interval
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="center-slider-container">
      <button className="slider-btn left" onClick={prevSlide}>
        &#10094;
      </button>
      <div className="slider">
        {images.map((image, index) => {
          const position =
            index === currentIndex
              ? "center"
              : index === (currentIndex + 1) % images.length
              ? "right"
              : index === (currentIndex - 1 + images.length) % images.length
              ? "left"
              : "hidden";

          return (
            <div
              key={index}
              className={`slide ${position}`}
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          );
        })}
      </div>
      <button className="slider-btn right" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default ImageSlider;
